import React from "react";
import Banner from "@ui/Banner";
import { useModal } from "@ui/Modals/ModalContext";

export type GenericBannerText = {
  startTrialBannerSubtitle: string;
  startTrialBannerTitle: string;
  startTrialBannerButtonText: string;
  waitText: string;
  closeText: string;
};

const BannerSection = ({ genericText }: { genericText: GenericBannerText }) => {
  const { showSignUpModal } = useModal();

  return (
    <div className="relative my-10 max-w-full">
      <Banner
        onClick={() => {
          showSignUpModal();
          window.gtag?.("event", "sign_up_step_1", {
            button_text: genericText,
          });
        }}
        submitButtonId="banner_start_trial_button"
        genericText={genericText}
      />
    </div>
  );
};

export default BannerSection;
